/* eslint-disable react/display-name */
import React, { memo } from 'react';
import styled from 'styled-components';
import { mediumMediaQuery, smallMediaQuery } from '../../../common/utilities/sizeHelpers';
import { DisplayAdWidget } from '../../ads/displayAdWidget.jsx';
import { withScreenSize } from '../../common/utilities/withScreenSize.jsx';
import { AirQualityStories } from '../airQualityStories';
import { AirQualitySummarySection } from './airQualitySummarySection';
import { AqiSummarySectionAdWrapper } from './styles';
import { DisplayAdUnit } from '../../../containers/ads/displayAdUnitContainer';

interface AirQualitySummaryArticleSectionProps {
    isDesktop: boolean;
    isMobile: boolean;
}

export const AirQualitySummaryArticleSection = withScreenSize(memo(({ isDesktop, isMobile }: AirQualitySummaryArticleSectionProps) => {
    return (
        <Container>
            <InfoContainer>
                <AirQualitySummarySection isDesktop={isDesktop} isMobile={isMobile} />
                <AirQualityStories/>
            </InfoContainer>

            { isDesktop 
                && <AqiSummarySectionAdWrapper>
                    <DisplayAdUnit slotId='air-quality_summaryarticle_x16' width={300} height={600} />
                </AqiSummarySectionAdWrapper> 
            }
        </Container>
    );
}));

const Container = styled.section`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
    margin-top: 40px;
    @media ${mediumMediaQuery} {
        margin-top: 24px;
    }
    @media ${smallMediaQuery} {
        margin-top: 10px;
        flex-direction: column;
    }
`;

const InfoContainer = styled.div`
    flex-direction: column;
    width: 100%;
`;
